import * as React from 'react';

export const BottomLineLabel = ({ viewBox }: { viewBox: any }) => {
  // Start at x=0 to align with the chart title (left-aligned)
  const lineStartX = 0;
  // Line extends to the right edge of the chart area
  const lineEndX = viewBox.x + (viewBox.width || 1000);

  return (
    <g>
      {/* Solid horizontal line at the bottom */}
      <line
        x1={lineStartX}
        y1={viewBox.y}
        x2={lineEndX}
        y2={viewBox.y}
        stroke="hsl(var(--custom-grey))"
        strokeWidth={0.5}
      />
    </g>
  );
};
